import {Outlet} from 'react-router-dom';
import {Menu} from "../menu/Menu";
import Footer from "../footer/Footer";
import SideBar from "../side_bar/SideBar";
import HomeLayout from "./HomeLayout";
import $ from "jquery";
import {RiMenu4Line} from "react-icons/ri";
import {useState} from "react";
import {BiChevronLeft, BiChevronRight} from "react-icons/bi";

export default function DashboardLayout() {
    const [isExpand, setIsExpand] = useState(true)
    return (
        <div className={`dashboardLayout ${isExpand ? 'expanded' : 'collapse'}`}>
            <button className={'btn-dashboard-hide'} onClick={() => setIsExpand(!isExpand)}>
                {isExpand ? <BiChevronLeft/> : <BiChevronRight/>}
            </button>
            <SideBar setIsExpand={setIsExpand}/>
            <div className="d-container">
                <button className="btn-mobile-menu btn-dashboard" onClick={() => {
                    $('#side_panel').addClass('show');
                }}>
                    <RiMenu4Line/>
                </button>
                <Outlet/>
            </div>
        </div>
    )
}
